import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { useMedia } from '@/hooks';
import { cardsData, cardsSizes } from './helpers';

import { ScCards } from './styled';

interface iCardsProps {
  translation: string;
}

export const Cards = ({ translation }: iCardsProps) => {
  const { t } = useTranslation(translation);
  const { isMobile } = useMedia();

  const widthImg = isMobile
    ? cardsSizes.mobile.width
    : cardsSizes.desktop.width;

  const heightImg = isMobile
    ? cardsSizes.mobile.height
    : cardsSizes.desktop.height;

  return (
    <ScCards>
      <div className="title">{t('title.block')}</div>
      <div className="wrapper-img">
        {cardsData.map((item, index) => (
          <div className="card-item" key={index}>
            <ImageComponent
              alt={item.alt}
              height={heightImg}
              src={item.img}
              width={widthImg}
            />
            <div className="wrapper-text">
              <span className="card-title">{t(item.title)}</span>
              <span className="card-description">{t(item.description)}</span>
            </div>
          </div>
        ))}
      </div>
    </ScCards>
  );
};
